import { Alert, Snackbar, Tooltip } from "@mui/material";
import { StatusOcupante } from "../../components/StatusOcupante/StatusOcupante";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";


const columnsOcupante = [
    { 
        field: 'Situacao',
        headerName: 'Situação',
        renderCell: (params) => (
            <StatusOcupante value={params.value} />
        )
    },
    { field: 'Codigo', headerName: 'Ocupante', flex: 1, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'Nome', headerName: 'Nome', flex: 2, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'Inscricao', headerName: 'Inscrição', flex: 1.5,
        renderCell: (params) => {
            if(!params.value) {
                return '';
            }
        
            return params.value.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/, '$1.$2.$3/$4-$5')
        }
    },
    { field: 'NomeRepresentante', headerName: 'Nome do representante', flex: 2, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'CpfRepresentante', headerName: 'CPF do representante', flex: 2,
        renderCell: (params) => {
            if(!params.value) {
                return '';
            }
        
            return params.value.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4");
        }
    },
    {  field: 'DataCadastro', headerName: 'Data de cadastro', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });
            
            return dataFormatada;
        }
    },
    {  field: 'DataAto', headerName: 'Data de autorização', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataAto, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });
            
            return dataFormatada;
        }
    },
    { field: 'NumeroTermoAutorizacao', headerName: 'Número do termo autorização', flex: 0.5,
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    }]

export { columnsOcupante };